<template>
    <Fragment>
    
        <!-- pagination -->
    
        <div class="catalog_pagination clearfix mt_xs" id="paginator">
    
            <div class="form-inline">
    
                <a v-if="current < last" class="btn btn_sm btn_neutral pagination_nextpage fmt_sm fmr_sm" 
                    :href="path +'?page=' + (current + 1)"
                    rel="next"
                    aria-label="Вперёд &raquo;"
                    >
                    Следующая страница
                </a>
    
                <ul class="pagination pagination-sm pagination_pages fmt_sm">

                    <li v-for="(item, index) in pages.first" class="page-item" :class="{ active: item == current}" aria-current="page">
                        <span v-if="item == current" class="page-link">{{ item }}</span>
                        <a v-else :href="getPageUrl(item)" class="page-link">{{ item }}</a>
                    </li>

                    <li v-if="pages.slider && pages.slider.length"><span class="page-link">...</span></li>

                    <li v-for="(item, index) in pages.slider" class="page-item" :class="{ active: item == current}" aria-current="page">
                        <span v-if="item == current" class="page-link">{{ item }}</span>
                        <a v-else :href="getPageUrl(item)" class="page-link">{{ item }}</a>
                    </li>

                    <li v-if="pages.last && pages.last.length"><span class="page-link">...</span></li>

                    <li v-for="(item, index) in pages.last" class="page-item" :class="{ active: item == current}" aria-current="page">
                        <span v-if="item == current" class="page-link">{{ item }}</span>
                        <a v-else :href="getPageUrl(item)" class="page-link">{{ item }}</a>
                    </li>
                    
                </ul>
    
            </div>
    
        </div>
    
        <!-- //pagination -->  
    
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {

    components: { Fragment },

    props: ['lastPage', 'currentPage', 'path', 'query'],

    data: function() {
        return {
            onEachSide: 3
        };
    },

    methods: {

        getSmallSlider() {
            return {
                first: this.getUrlRange(1, this.last),
                slider: null,
                last: null,
            };
        },

        getUrlSlider(onEachSide) {
            let window = onEachSide + 4;

            if (!this.last) {
                return { first: null, slider: null, last: null };
            }

            // If the current page is very close to the beginning of the page range, we will
            // just render the beginning of the page range, followed by the last 2 of the
            // links in this list, since we will not have room to create a full slider.
            if (this.current <= window) {
                return this.getSliderTooCloseToBeginning(window, onEachSide);
            }

            // If the current page is close to the ending of the page range we will just get
            // this first couple pages, followed by a larger window of these ending pages
            // since we're too close to the end of the list to create a full on slider.
            else if(this.current > this.last - window) {
                return this.getSliderTooCloseToEnding(window, onEachSide);
            }

            // If we have enough room on both sides of the current page to build a slider we
            // will surround it with both the beginning and ending caps, with this window
            // of pages in the middle providing a Google style sliding paginator setup.
            return this.getFullSlider(onEachSide);
        },

        getSliderTooCloseToBeginning(window, onEachSide) {
            return {
                first: this.getUrlRange(1, window + onEachSide),
                slider: null,
                last: this.getFinish(),
            };
        },

        getSliderTooCloseToEnding(window, onEachSide) {
            let last = this.getUrlRange(
                this.last - (window + (onEachSide - 1)),
                this.last
            );

            return {
                first: this.getStart(),
                slider: null,
                last: last,
            };
        },

        getFullSlider(onEachSide) {
            return {
                first: this.getStart(),
                slider: this.getAdjacentUrlRange(onEachSide),
                last: this.getFinish(),
            };
        },
        
        getStart() {
            console.log('getStart', this.getUrlRange(1, 2));
            return this.getUrlRange(1, 2);
        },
        
        getFinish() {
            return this.getUrlRange(
                this.last - 1,
                this.last
            );
        },

        getAdjacentUrlRange(onEachSide)
        {
            return this.getUrlRange(
                this.current - onEachSide,
                this.current + onEachSide
            );
        },

        getUrlRange(start, end) {
            let length = end - start + 1;

            return Array.from({ length }, (_, i) => start + i);
        },

        getPageUrl(page) {
            const params = new URLSearchParams({...this.query, page: page});

            return this.path + '?' + params.toString();
        }
    },

    computed: {
        last() {
            return this.$store.state.catalog.lastPage;
        },

        current() {
            return this.$store.state.catalog.currentPage;
        },

        pages() {
            if (this.last < (this.onEachSide * 2) + 8) {
                return this.getSmallSlider();
            }

            return this.getUrlSlider(this.onEachSide);
        },
    },

    mounted: function() {
        this.$store.dispatch('catalog/setCurrentPage', parseInt(this.currentPage));
        this.$store.dispatch('catalog/setLastPage', parseInt(this.lastPage));
    }
};
</script>
